// extracted by mini-css-extract-plugin
export default {"add__admin":"AddAdmin_add__admin__WU1eE","inputs":"AddAdmin_inputs__SY7Ip"};